import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/listing/CategoryFilmKop.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/listing/CategoryPageClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/listing/DestinationFavoriteButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/listing/ExpandableIntro.js");
